import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateKeywordRunRequest, KeywordRun } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateKeywordRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateKeywordRunRequest) =>
      apiPost<KeywordRun>('/v1/keyword-runs', input),
    onSuccess: (run) => {
      void qc.invalidateQueries({ queryKey: ['keyword-runs'] });
      qc.setQueryData(['keyword-run', run.id], run);
    },
  });
}
